
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Image } from 'react-bootstrap';

const Error_404 = () => {
    const navigate = useNavigate();

    return (
       <>
          <div className='content-404'>
            <div className='text-center'>
                <Image src='/assets/images/404.png' className='img-404'/>
                <h1 className='font-20 font-weight-bold mb-1 page-heading'>404! The page you are looking for isn’t here</h1>
                <p className='font-12 font-weight-normal text-secondary mb-3'>You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation</p>
                <Button onClick={() => navigate('/')} className='font-13 font-weight-s-bold p-2 px-3' >Back to home</Button>
            </div>
          </div>
       </>
    );
};

export default Error_404;
